import {Typography} from '@mui/material';
import {AmountField} from '@resurs-internal/mui';
import {tryParseFloat, useCountry} from '@resurs-internal/rb-app-api';
import {FieldErrors, UseFormRegister} from 'react-hook-form';
import {useTranslate} from 'hooks';
import {MonthlyDepositFormValues} from './hooks/useMonthlyDepositForm';

type MonthlyDepositAmountFieldProps = {
  register: UseFormRegister<MonthlyDepositFormValues>;
  errors: FieldErrors<MonthlyDepositFormValues>;
  amount: string;
};

export const MonthlyDepositAmountField = ({
  register,
  errors,
  amount,
}: MonthlyDepositAmountFieldProps) => {
  const translate = useTranslate();
  const country = useCountry();

  return (
    <>
      <Typography variant={'body1'} sx={{fontWeight: 700}}>
        {translate('savings.deposit.monthly.amount')}
      </Typography>
      <AmountField
        label={translate('savings.deposit.monthly.amount-placeholder')}
        value={amount}
        error={Boolean(errors.amount)}
        helperText={errors.amount?.message}
        formatNumber={(value) =>
          country.formatAmount({
            amount: value,
            currency: country.currency,
          })
        }
        {...register('amount', {
          required: true,
          validate: (s) => {
            if ((tryParseFloat(String(s)) || 0) <= 0)
              return translate('common.invalid-input');
          },
        })}
      />
    </>
  );
};
